import styled from 'styled-components';
import { Divider } from 'ui/divider';
import { body1, body2, fontSizes, fontWeights, letterSpacing, spacing, textColors } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { HighestCampaignsTable } from './HighestCampaignsTable';
import { useTranslation } from '../../../../hooks';
import { useConversionInsightsContext } from '../../../../contexts/behaviorInsights/conversionInsights';

const Wrapper = styled.div`
  ${body1};
  margin: 0 -${spacing.base} 0 -${spacing.plusHalf};
  padding: 0 ${spacing.base} 0 ${spacing.plusHalf};
`;

const StyledDivider = styled(Divider)`
  margin-top: 0;
  padding: 0;
`;

const Title = styled.div`
  ${body2};
  font-size: ${fontSizes.s11};
  line-height: ${spacing.threeQuarter};
  letter-spacing: ${letterSpacing.pos200};
  font-weight: ${fontWeights.semiBold};
  color: ${textColors.textSecondary};
  padding-bottom: ${pxToRem(14)};
`;

export const HIGHEST_CAMPAIGNS_DATA_TEST = 'highest-converting-campaign-section';

export const HighestCampaignsSection = () => {
  const { t } = useTranslation();
  const { highestConvertingCampaigns, isLoading } = useConversionInsightsContext();
  const title = t('insights.highestCampaigns');

  return (
    <>
      {!!highestConvertingCampaigns.length && (
        <Wrapper data-test={HIGHEST_CAMPAIGNS_DATA_TEST}>
          <StyledDivider />
          <Title>{title}</Title>
          <HighestCampaignsTable values={highestConvertingCampaigns} isLoading={isLoading} />
        </Wrapper>
      )}
    </>
  );
};
